// correctionDetector.js
import * as relationship from './corrections/relationshipCorrection.js';

const modules = [relationship];

/**
 * 🔍 Detects if a correction is present in the message.
 * If so, returns { match: true, target: { name, role, type } }
 * Used in Chat.js to confirm before applying.
 */
export function checkForCorrection(message) {
  for (const mod of modules) {
    const result = mod.detectCorrection(message);
    if (result?.match) {
      console.log('🕵️ Detected correction candidate:', result.target);
      return result;
    }
  }
  return { match: false };
}

/**
 * ❌ DEPRECATED – Use checkForCorrection + applyCorrection separately instead.
 * Originally auto-applied correction without user confirmation.
 */
export async function checkAndApplyCorrection(message, shadowId) {
  console.warn('⚠️ checkAndApplyCorrection is deprecated. Use checkForCorrection() and applyCorrection() instead.');
  for (const mod of modules) {
    const result = mod.detectCorrection(message);
    if (result?.match) {
      return await mod.applyCorrection(result.target, shadowId);
    }
  }
  return null;
}

